import type {ReactNode} from 'react'
import {cn} from '@/lib/utils'

export type SegmentedOption<T extends string> = {key: T; label: ReactNode; testId?: string}

/** No es `ui/tabs.tsx`: las tabs cambian de contenido; esto cambia el ángulo del mismo contenido. */
export function SegmentedControl<T extends string>({
  options,
  value,
  onChange,
  size = 'default',
  className,
  testId,
  ariaLabel,
}: {
  options: SegmentedOption<T>[]
  value: T
  onChange: (key: T) => void
  size?: 'sm' | 'default'
  className?: string
  testId?: string
  ariaLabel?: string
}) {
  return (
    <div
      className={cn('inline-flex w-fit gap-0.5 rounded-lg bg-secondary p-0.5', className)}
      role="group"
      aria-label={ariaLabel}
      data-testid={testId}>
      {options.map((option) => (
        <button
          key={option.key}
          type="button"
          aria-pressed={value === option.key}
          data-testid={option.testId}
          onClick={() => onChange(option.key)}
          className={cn(
            'rounded-md whitespace-nowrap transition-colors',
            size === 'sm' ? 'px-2.5 py-1 text-xs' : 'px-3 py-1.5 text-sm',
            value === option.key
              ? 'bg-card font-medium text-primary shadow-xs'
              : 'text-muted-foreground hover:text-foreground'
          )}>
          {option.label}
        </button>
      ))}
    </div>
  )
}
